import React from 'react';
import { Row, Col, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import * as Config from '../../../Config';

const { Text, Title } = Typography;

const ContentSection = (props) => {
    const {
        background,
        title,
        description,
        contentOffset,
        orderContent,
        imageOffset,
        orderImage,
        image,
    } = props;
    return (
        <div>
            {/* Content Section */}
            <Row
                align='middle'
                style={{
                    padding: '120px 0',
                    backgroundColor: background,
                }}
            >
                <Col
                    xs={{ span: 24, order: 2 }}
                    lg={{
                        span: 10,
                        offset: contentOffset,
                        order: orderContent,
                    }}
                    style={{ padding: '2rem' }}
                >
                    <Col>
                        <Title style={{ fontSize: '44px' }}>{title}</Title>
                        <Text style={{ fontSize: '20px' }}>{description}</Text>
                    </Col>
                    <Col
                        xs={24}
                        sm={18}
                        lg={12}
                        style={{ padding: '1.5rem 2rem 0 0' }}
                    >
                        <Text
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                const returnTo = window.location.origin;
                                window.location.href = `https://auth.rajchandra.me/login?returnTo=${encodeURIComponent(returnTo)}`;
                            }}
                        >
                            Learn More <ArrowRightOutlined />
                        </Text>
                    </Col>
                </Col>
                <Col
                    xs={{ span: 24, order: 1 }}
                    lg={{
                        span: 8,
                        offset: imageOffset,
                        order: orderImage,
                    }}
                    style={{ padding: '0 2rem' }}
                >
                    <img src={image} alt='<app_name>' width='100%' />
                </Col>
            </Row>
        </div>
    );
};

export default ContentSection;
